import React from 'react';
import ReactDOM from 'react-dom';
import './radio_button.less';

class RadioButton extends React.Component{
  constructor(props){
    super(props);
    this.createCheckBox = this.createCheckBox.bind(this);
    this.selectedCheckBox = this.selectedCheckBox.bind(this);
    this.state = {
      selected: ''
    }
  }

  selectedCheckBox(selectedRadioButton){
    this.setState({
      selected: selectedRadioButton
    })
    this.props.getValueCallback(selectedRadioButton);
  }

  changeRadioButton = () => {
  }

  createCheckBox(dataArr, radioButtonName, radioButtonDetails){
    const {props} = this;
    let self = this;
    let checkBoxArr = [];
    let selected;
    (props.selected == null || props.selected == undefined) ?  (selected = null) : (selected = props.selected);

    if((dataArr != null || dataArr != undefined || dataArr != '') && dataArr && dataArr.length > 0){

      (selected >= dataArr.length) ? (selected = 0) : (selected = selected);

      dataArr.forEach( (CheckBoxLabelText, index) => {

        if(radioButtonDetails == null) {
          if(selected == index){
            checkBoxArr.push( <div className="radio-button" key={index}><input checked="true" onChange={this.changeRadioButton} className="checkbox" type="radio" name={radioButtonName} onClick={this.selectedCheckBox.bind(self, CheckBoxLabelText)} value={radioButtonName} id={radioButtonName + index} /><label className="radio-button-label" htmlFor={radioButtonName + index}></label> <label htmlFor={radioButtonName + index} className="radio-button-background" ></label><label htmlFor={radioButtonName + index} className="radio-button-name" >{CheckBoxLabelText}</label></div> );
          }else{
            checkBoxArr.push( <div className="radio-button" key={index}><input className="checkbox" onChange={this.changeRadioButton} type="radio" name={radioButtonName} onClick={this.selectedCheckBox.bind(self, CheckBoxLabelText)} value={radioButtonName} id={radioButtonName + index} /><label className="radio-button-label" htmlFor={radioButtonName + index}></label> <label htmlFor={radioButtonName + index} className="radio-button-background" ></label><label htmlFor={radioButtonName + index} className="radio-button-name" >{CheckBoxLabelText}</label></div> );
          }
        }else{
          if(selected == index){
            checkBoxArr.push( <div className="radio-button" key={index}><input checked="true" className="checkbox" onChange={this.changeRadioButton} type="radio" name={radioButtonName} onClick={this.selectedCheckBox.bind(self, CheckBoxLabelText)} value={radioButtonName} id={radioButtonName + index} /><label className="radio-button-label" htmlFor={radioButtonName + index}></label> <label htmlFor={radioButtonName + index} className="radio-button-background" ></label><label htmlFor={radioButtonName + index} className="radio-button-name" ><div className="radio-button-option-details-wrap"><div className="radio-button-option">{CheckBoxLabelText}</div><div className="radio-button-option-details">{radioButtonDetails[index]}</div></div></label></div> );
          }else{
            checkBoxArr.push( <div className="radio-button" key={index}><input className="checkbox" onChange={this.changeRadioButton} type="radio" name={radioButtonName} onClick={this.selectedCheckBox.bind(self, CheckBoxLabelText)} value={radioButtonName} id={radioButtonName + index} /><label className="radio-button-label" htmlFor={radioButtonName + index}></label> <label htmlFor={radioButtonName + index} className="radio-button-background" ></label><label htmlFor={radioButtonName + index} className="radio-button-name" ><div className="radio-button-option-details-wrap"><div className="radio-button-option">{CheckBoxLabelText}</div><div className="radio-button-option-details">{radioButtonDetails[index]}</div></div></label></div> );
          }
        }


      })
      return checkBoxArr;
      // return dataArr.map((CheckBoxName, index) = > { <div className="radio-button"> <input type="radio" name={CheckBoxName} key={} value={CheckBoxName} /> {CheckBoxName}</div> });
    }
  }

  render(){
    const {props, state} = this;
    let radioButtonNameArray = props.radioButtonNameArray;
    let radioButtonName = props.radioButtonName;
    let radioButtonDetails;
    (props.radioButtonDetails) ? (radioButtonDetails = props.radioButtonDetails) : (radioButtonDetails = null);
    let checkBoxString = this.createCheckBox(radioButtonNameArray, radioButtonName, radioButtonDetails);

    return (
      <div className="radio-button-wrap">
        {checkBoxString}
      </div>
    )
  }
}

RadioButton.propTypes = {
  radioButtonNameArray: React.PropTypes.array.isRequired,
  selected: React.PropTypes.number,
  getValueCallback: React.PropTypes.func.isRequired,
  radioButtonName: React.PropTypes.string.isRequired

}

export default RadioButton;

// props
// radioButtonNameArray : ['selectbox1', 'selectbox2', 'selectbox3'];
// seletced = {0} first element will be selected by default
// if not sent then nothing will be selected
// The names of the se
// radioButtonName: 'checkbox'
// getValueCallback is a function to which selected
// select box's value is sent

// sample call
//     let checkboxArr = ["Tesla", "Chevy Volt", "BMW i3"];
//  <RadioButton radioButtonNameArray = {checkboxArr} selected={0} radioButtonName={'checkbox'} getValueCallback = { this.getRadioButtonValue } />
// getRadioButtonValue(selected){
//   console.log('selected-check-box',  selected);
// }



// WEBPACK FOOTER //
// app/components/radio_button/radio_button.jsx